import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../../../lib/store';

import { useIsMobile } from '../../../../../../../hooks';
import AppVersion from '../../../../../../AppVersion/AppVersion';
import { Preloader } from '../../../../../../index';
import PersonalContactDetails from '../personalContactDetails/PersonalContactDetails';
import PersonalNameDetails from '../personalNameDetails/PersonalNameDetails';

import styles from './PersonalDetailsComponent.module.scss';

const PersonalDetailsComponent = (props: ReduxProps) => {
  const { individual } = props;
  const { isMobile } = useIsMobile();

  if (!individual) {
    return <div className={styles.loader}><Preloader owner="Personal Details" text="" /></div>;
  }

  const { first_name, middle_name, last_name, email, phone_number } = individual;

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperPersonalDetails}>
        <PersonalNameDetails
          firstName={first_name}
          middleName={middle_name || ''}
          lastName={last_name}
        />
        <PersonalContactDetails email={email} phoneNumber={phone_number || ''} />
      </div>
      {!isMobile && <AppVersion />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PersonalDetailsComponent);
